import type {CandidateEvaluationWithRecruiterHubState} from 'src/types/candidate-evaluation-with-recruiter-hub';
import type {NodeSchedule} from 'src/types/node-schedule';

import type {Dispatch, ThunkAction} from 'src/reducers';

import * as reduxApiBff from 'src/utils/redux-api-bff';

import {parseCandidateEvaluationWithRecruiterHub} from 'src/utils/candidate-evaluation-with-recruiter-hub';


export const RECEIVE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO =
  'candidate-evaluation-with-recruiter-hub/receive';
export const UPDATE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO =
  'candidate-evaluation-with-recruiter-hub/update';
export const UPDATE_NODE_SCHEDULE_WITH_RECRUITER_HUB =
  'candidate-evaluation-with-recruiter-hub/update-node-schedule';
export const RESET_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO =
  'candidate-evaluation-with-recruiter-hub/reset';

export type CandidateEvaluationWithRecruiterHubPayload =
  Partial<CandidateEvaluationWithRecruiterHubState>;

type ReceiveInfo = {
  type: typeof RECEIVE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO;
  payload: CandidateEvaluationWithRecruiterHubPayload;
};

type UpdateInfo = {
  type: typeof UPDATE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO;
  payload: CandidateEvaluationWithRecruiterHubPayload;
};

type UpdateScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE_WITH_RECRUITER_HUB;
  payload: Partial<NodeSchedule>;
};

type ResetAction = {
  type: typeof RESET_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO;
};

export type CandidateEvaluationWithRecruiterHubAction =
  | ReceiveInfo
  | UpdateInfo
  | UpdateScheduleAction
  | ResetAction;

export const receiveCandidateEvaluationWithRecruiterHubInfo = (
  payload: CandidateEvaluationWithRecruiterHubState,
): ReceiveInfo => ({
  type: RECEIVE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO,
  payload,
});

export const updateCandidateEvaluationWithRecruiterHubInfo = (
  payload: CandidateEvaluationWithRecruiterHubPayload,
): UpdateInfo => ({
  type: UPDATE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO,
  payload,
});

export const updateNodeScheduleWithRecruiterHub = (
  payload: Partial<NodeSchedule>,
): UpdateScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE_WITH_RECRUITER_HUB,
  payload,
});

export const resetCandidateEvaluationWithRecruiterHubInfo =
  (): ResetAction => ({
    type: RESET_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO,
  });

export const getCandidateEvaluationWithRecruiterHubTaskNode: (
  node_id: string,
) => ThunkAction<unknown> = (node_id) => async (dispatch: Dispatch) => {
  const fetchedNodeResponse = await dispatch(
    reduxApiBff.get(`node/composite`, {
      node_id,
    }),
  );
  const parsed = parseCandidateEvaluationWithRecruiterHub(
    fetchedNodeResponse.body,
  );

  return dispatch(receiveCandidateEvaluationWithRecruiterHubInfo(parsed));
};
